import { Navigate } from "react-router-dom";
import { UserAuth } from "../context/authContext";

const ProtectedRoute = ({ children }) => {
  const { user } = UserAuth();

  // Handle case where user might be null (logged out) or explicitly not initialized
  if (!user || user === null) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
